import { useCallback, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { DIETS_QUERY } from '../graphql/queries'
import { COMMON_FETCH_DIETS } from '../redux/action-types'
import { cleanupCommonFetchDiets } from '../redux/actions'
import { apolloService } from '../services'

import useCleanupRedux from './use-cleanup-redux'

const useDietsQuery = filters => {
  const dispatch = useDispatch()
  useCleanupRedux(cleanupCommonFetchDiets)

  const { isLoading, error, data, options } = useSelector(
    store => store.common.diets,
  )

  const refetch = useCallback(
    () =>
      apolloService.query(
        DIETS_QUERY,
        { filters },
        dispatch,
        COMMON_FETCH_DIETS,
      ),
    [dispatch, filters],
  )

  useEffect(() => {
    refetch()
  }, [refetch])

  return { isLoading, error, data, options }
}

export default useDietsQuery
